const initialState = {
  status: {},
}

const initialStatus = {
  loading: false,
  success: false,
  error: false,
  data: null,
  message: null,
}

const userConfigReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'RESET_USER_CONFIG':
      const { [action.payload]: key, ...rest } = state.status
      return !key
        ? initialState
        : {
            ...state,
            status: {
              ...rest,
            },
          }
    case 'USER_CONFIG_ERROR':
      return {
        ...state,
        status: {
          ...state?.status,
          [action?.payload?.action]: {
            ...initialStatus,
            error: true,
            message: action?.payload?.message,
          },
        },
      }
    case 'GET_USER_CONFIG':
      return {
        ...state,
        status: {
          get_user_config: {
            ...initialStatus,
            loading: true,
          },
        },
      }
    case 'SET_USER_CONFIG':
      return {
        ...state,
        configs: [...action.payload],
        status: {
          get_user_config: {
            ...initialStatus,
            success: true,
          },
        },
      }
    case 'ADD_FAVORITE_TRANSFER':
      return {
        ...state,
        status: {
          add_favorite_transfer: {
            ...initialStatus,
            loading: true,
            data: { ...action.payload },
          },
        },
      }
    case 'ADDED_FAVORITE_TRANSFER': {
      const type = action?.payload?.type
      const itemId = action?.payload?.itemId
      const configId = action?.payload?.configId
      const index = state.configs.findIndex((e) => e.id === configId)

      // add new values to original array
      if (index >= 0) {
        state.configs[index].info[`${type}_id`].push(itemId)
      } else {
        const aux = state.configs
        aux.push({
          id: configId,
          category: `transfer_${type}s`,
          info: { [`${type}_id`]: [itemId] },
        })

        state.configs = aux
      }

      return {
        ...state,
        configs: state.configs,
        status: {
          add_favorite_transfer: {
            ...initialStatus,
            success: true,
            message: action?.payload?.message,
          },
        },
      }
    }
    case 'DELETE_FAVORITE_TRANSFER':
      return {
        ...state,
        status: {
          delete_favorite_transfer: {
            ...initialStatus,
            loading: true,
            data: action.payload,
          },
        },
      }
    case 'DELETED_FAVORITE_TRANSFER': {
      const type = action?.payload?.type
      const itemId = action?.payload?.itemId
      const configId = action?.payload?.configId
      const index = state.configs.findIndex((e) => e.id === configId)
      let el = state.configs[index]?.info[`${type}_id`]
      let newEl = el.filter((el) => el !== itemId)

      // copy new values to original array
      state.configs[index].info[`${type}_id`] = newEl

      return {
        ...state,
        configs: state.configs,
        status: {
          delete_favorite_transfer: {
            ...initialStatus,
            success: true,
            message: action?.payload?.message,
          },
        },
      }
    }

    default:
      return state
  }
}

export default userConfigReducer
